import { get, post, put, del } from 'common/axiosClient';
import { InputQCCReportDTO, QCCReport, QCCReportInfo } from './quarterly-cc-report.type';
import {
  BulkDeleteCCReportsDTO,
  CCReportComp,
  addCompsToCCReportDTO,
  costPerDivision,
} from '../construction-cost-report/construction-cost-report.type';
import { API } from '../../common/constants/urls';

export const getQCCReports = async (queryParams: string[]) => {
  const queryString = queryParams.join('&');
  return (await get(`${API.QUARTERLY_CC_REPORTS}?${queryString}`)) as { total: number; reportsList: QCCReportInfo[] };
};

export const getQCCReport = async (reportId: string) => {
  return (await get(`${API.QUARTERLY_CC_REPORTS}/${reportId}`)) as QCCReport;
};
export const getCostPerDivisionForQCC = async (reportId: string) => {
  return (await get(`${API.QUARTERLY_CC_REPORTS}/${reportId}/cost-per-division`)) as costPerDivision;
};

export const createQCCReport = async (requestDto: InputQCCReportDTO) => {
  return (await post(API.QUARTERLY_CC_REPORTS, requestDto)) as QCCReport;
};

export const updateQCCReport = async (reportId: string, requestDto: InputQCCReportDTO) => {
  return (await put(`${API.QUARTERLY_CC_REPORTS}/${reportId}`, requestDto)) as QCCReport;
};

export const deleteQCCReport = async (reportId: string) => {
  return (await del(`${API.QUARTERLY_CC_REPORTS}/${reportId}`)) as string;
};

export const bulkDeleteQCCReports = async (dto: BulkDeleteCCReportsDTO) => {
  return (await post(`${API.QUARTERLY_CC_REPORTS}/bulk-delete`, dto)) as string;
};

export const updateQCCReportComps = async (reportId: string, comps: CCReportComp[]) => {
  return (await put(`${API.QUARTERLY_CC_REPORTS}/${reportId}/comps`, comps)) as QCCReport;
};
export const addCompsToQCCReport = async (inputDTO: addCompsToCCReportDTO) => {
  return await post(`${API.QUARTERLY_CC_REPORTS}/add-comps`, inputDTO);
};

export const getComparablesCount = async (inputDTO: InputQCCReportDTO) => {
  return await post(`${API.QUARTERLY_CC_REPORTS}/get-comps-count`, inputDTO);
};
